import { render, staticRenderFns } from "./TableListConfig.vue?vue&type=template&id=5bbee00a&scoped=true&"
import script from "./TableListConfig.vue?vue&type=script&lang=js&"
export * from "./TableListConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbee00a",
  null
  
)

export default component.exports